import { GoogleAnalyticsEventsType } from '@nw/shared/config';

import { SegmentEvent } from '../../../../shared/stores/models/SegmentEvent';

import { ProductSegmentConfigDTO } from '../../../stores/dtos/product.dtos';

export class ProductSegmentEvent {
  shouldSendSegmentEvent: boolean | undefined;
  segmentEventsTypes: Record<string, SegmentEvent> | undefined;
  googleAnalyticsEvents: GoogleAnalyticsEventsType | undefined;

  constructor(segmentEventsInfo: ProductSegmentConfigDTO | undefined) {
    this.shouldSendSegmentEvent = segmentEventsInfo?.shouldSendSegmentEvent;
    this.googleAnalyticsEvents =
      segmentEventsInfo?.googleAnalyticsEvents &&
      segmentEventsInfo.googleAnalyticsEvents;
    if (segmentEventsInfo?.segmentEventsTypes) {
      const { segmentEventsTypes } = segmentEventsInfo;

      Object.keys(segmentEventsTypes).forEach((key) => {
        if (this.segmentEventsTypes && segmentEventsTypes[key]) {
          this.segmentEventsTypes[key] = new SegmentEvent(
            segmentEventsTypes[key]
          );
        } else {
          this.segmentEventsTypes = {};
          this.segmentEventsTypes[key] = new SegmentEvent(
            segmentEventsTypes[key]
          );
        }
      });
    }
  }
}
